export const DRAWER_TYPES = {
  CERTIFICATION: 'certification',
  PRICE_INDICATOR: 'priceIndicator',
  RENTING_SERVICES: 'rentingServices',
  INCLUDED_EXTRAS: 'includedExtras',
  TECHNICAL_DETAILS: 'technicalDetails',
  NO_COMMISSIONS: 'noCommissions',
  CARFAX: 'carfax',
  REPORT_AD: 'reportAd',
  SELLER_SERVICES: 'sellerServices',
  DEALER_RATINGS: 'dealerRatings',
  INSURANCE_INFO: 'insuranceInfo',
  /**
   * The one type with no entry in DRAWER_RENDERERS, so DetailDrawer resolves it to
   * null instead of an empty drawer: the body is the portalled FormDrawer of the
   * single live ContactForm instance, and registering a renderer here would
   * be a second mount. What registration buys is the mutex — `activeDrawer` holding
   * this type is what closes every other drawer, and what satisfies DetailDrawer's
   * `oneOf(Object.values(DRAWER_TYPES))` when StickyContactBar asks for it.
   *
   * The literal must stay equal to CONTACT_DRAWER_TYPE in
   * @adv-mt/mt-form-contact-seller's StickyContactBar, which does not re-export it
   * through the package barrel — no import can enforce this, only the string.
   */
  CONTACT_FORM: 'contactForm'
}

/**
 * Next `activeDrawer` for an open/close intent coming from ContactForm.
 *
 * A close only clears state when the contact form is still the active drawer: the
 * form is notified on every close path, including the one caused by another drawer
 * taking `activeDrawer` over, and an unguarded `null` there would immediately shut
 * the drawer that just opened.
 */
export const resolveContactFormDrawer = (activeDrawer, isOpen) => {
  if (isOpen) {
    return {type: DRAWER_TYPES.CONTACT_FORM}
  }

  return activeDrawer?.type === DRAWER_TYPES.CONTACT_FORM ? null : activeDrawer
}
